import axios from "axios";
import { apiVariable } from "./apiVariable";

export interface InvoicePreview {
  url: string;
  contentType: string;
}

const invoiceExtensions = ["pdf", "jpg", "jpeg", "png"];

export const getInvoicePreview = async (
  repairId: string,
  token?: string | null,
): Promise<InvoicePreview> => {
  for (const extension of invoiceExtensions) {
    try {
      const response = await axios.get(
        `${apiVariable}/download/${repairId}/invoice/${extension}`,
        {
          responseType: "blob",
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.status === 200) {
        const fallbackType =
          extension === "pdf"
            ? "application/pdf"
            : `image/${extension === "jpg" ? "jpeg" : extension}`;
        return {
          url: window.URL.createObjectURL(response.data),
          contentType: response.data.type || fallbackType,
        };
      }
    } catch (error: any) {
      if (error.response?.status !== 500 && error.response?.status !== 404) {
        throw error;
      }
    }
  }

  throw new Error("No invoice file was found for this repair.");
};
